/**
 * Template - Data mapper for RFI1 - Fabric
 * Section UID (in template) : Section Path in data
 */
export const rfi1FabricSectionMapper = {
  //Business Capabilities
  supplier_primary_information:
    'dynamic_sections.business_capability.supplier_primary_information',
  top_fabrics_sold: 'dynamic_sections.business_capability.top_fabrics_sold',
  business_intelligence:
    'dynamic_sections.business_capability.business_intelligence',
  design_trend_rnd_capabilities:
    'dynamic_sections.business_capability.design_trend_rnd_capabilities',
  innovation: 'dynamic_sections.business_capability.innovation',
  certifications: 'dynamic_sections.business_capability.certifications',

  //Supply Chain
  total_top_yarns: 'dynamic_sections.supply_chain.total_top_yarns',
  total_top_fibers: 'dynamic_sections.supply_chain.total_top_fibers',
  top_garment_vendors: 'dynamic_sections.supply_chain.top_garment_vendors',

  //Responsible Sourcing
  responsible_sourcing_sustainability:
    'dynamic_sections.responsible_sourcing.responsible_sourcing_sustainability',

  color_capabilities: 'dynamic_sections.business_capability.color_capabilities',
}
